/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { normalizeLocalizedPath } from "@/utils/localizedPath";

/**
 * Returns the path prefixed with the current language if a non-English locale
 * is active, or the plain path for English.
 *
 * This function is intentionally side-effect-free — it reads from localStorage
 * and the URL, but never writes or fires network requests. IP geolocation is
 * initialised once at application startup in main.tsx (initLanguage), not on
 * every link render. Calling AddLangToPath on every Link render is safe
 * because it performs no I/O.
 */
export const AddLangToPath = (path: string): string => {
  const { lang } = normalizeLocalizedPath(window.location.pathname);
  if (lang) {
    return `/${lang}${path}`;
  }
  return path;
};
